import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, FormGroup, Input, Label, Button, NavItem, NavLink, Nav, TabContent, TabPane, Modal, ModalHeader, ModalBody, ModalFooter, Card } from 'reactstrap'
import { sendRequest } from '../../hooks/requests/useRequest';
import { useForm } from '../../hooks/forms/useForm';
import { classes } from '../../data/layouts';
import '../../index.scss'
import jwt_decode from "jwt-decode";
import '../../assets/css/loginCaptura.css'
import { useLogin } from '../../hooks/tomaMuestra/useLogin';
import { useSweetAlert } from '../../hooks/sweetAlerts/useSweetAlert';
import { cedimi } from '../../constant/globalConstantsTypeClients'
import { ConfigServer } from '../../data/config'




const LoginTomaDeMuestra = (props) => {

    const {

        departamento

    } = useLogin();


    const [loading, setLoading] = useState(false);
    const defaultLayoutObj = classes.find(item => Object.values(item).pop(1) === 'compact-wrapper');
    const layout = localStorage.getItem('layout') || Object.keys(defaultLayoutObj).pop();


    const [loged, setLoged] = useState(false);
    const jwt_token = localStorage.getItem('token');
    const tomaMuestra = localStorage.getItem('tomaMuestra');
    const [createSweet, sweetConfirmation, sweetError, createSweett] = useSweetAlert();
    const [togglePassword, setTogglePassword] = useState(false)
    const [show, setShow] = useState(true);
    let url_helen = localStorage.getItem('url_helen');


    //#region view
    const [cardView, setCardView] = useState(false);

    const handleViewCard = () => {
        setCardView(true);
    }

    const handleCloseCard = () => {
        setCardView(false);
    }



    //#endregion view


    useEffect(() => {
        if (loged === true) {
            window.location.href = `${process.env.PUBLIC_URL}`;
        }
    }, [loged]);

    const HideShowPassword = (tPassword) => {
        setTogglePassword(!tPassword)
    }



    const [formValues, handleInputChange, reset, handleUpdateValues, handleSelectValues] = useForm({
        id_departament: "",
        id_area: 19,
        card_code: "",
        userName: "",
        password: "",

    });

    const [validationsLogin, setValidationsLogin] = useState({
        id_departament: false,
        card_code: false,

    });


    const [setFocusCard, setSetFocusCard] = useState(true);

    const { id_departament, card_code } = formValues;

    const [showText, setShowText] = useState(false);

    const [shown, setShown] = React.useState(false);

    const switchShown = () => setShown(!shown);

    const [submitLogin, setSubmitLogin] = useState(false);

    const iniciarSesion = async (e) => {
        e.preventDefault();
        setShowText(false);
        setLoading(true);
        setSubmitLogin(true);
        if (!validationLogin()) {
            setLoading(false);
            return;
        }

        let raw = JSON.stringify(formValues);

        let requestOptions = {
            method: 'POST',
            body: raw,
        };

        const respuesta = await sendRequest(requestOptions, "Users/LoginSampling");

        if (respuesta.code === 200) {

            localStorage.setItem('depW', formValues.id_departament);


            let use_consent = departamento.find(x => x.id_departament == parseInt(formValues.id_departament))

            if (respuesta.data.msg !== "Éxito") {
                createSweet("", "warning", "Alerta", respuesta.data.msg, "warning");
                setLoading(false);
            }
            else {

                localStorage.setItem("token", respuesta.data.token);
                localStorage.setItem("id", respuesta.data.id_user);
                localStorage.setItem("flebotomistaUser", respuesta.data.username);
                localStorage.setItem("tomaMuestra", 2);
                localStorage.setItem("consentimientoInformado", (use_consent ? use_consent.use_consent : false));
                localStorage.setItem("flebotomisaNombre", respuesta.data.name);
                localStorage.setItem("willson", respuesta.data.nameDepartamento);
                localStorage.setItem("maquila", respuesta.data.maquila);
                localStorage.setItem("url_helen", respuesta.data.url_helen);


                setLoged(true);
            }

            handleUpdateValues({
                card_code: "",
                id_area: 19,
                id_departament: "",
                userName: "",
                password: "",
            })
        }
        else {

            handleUpdateValues({
                card_code: "",
                id_area: 19,
                id_departament: "",
                userName: "",
                password: "",
            })

            setShowText(true);
            setLoading(false);

        }
    }


    const [passwordd, setPasswordd] = React.useState('');
    const onChange = ({ currentTarget }) => setPasswordd(currentTarget.value);


    const cardAutoFocus = () => {
        if (setFocusCard) {
            if (document.getElementById("inputFocusCard") !== null) {
                document.getElementById("inputFocusCard").focus();
            }
        }
    }

    useEffect(() => {

        cardAutoFocus()

    }, [setFocusCard]);

    function onKeyPressCard(event) {

        if (event.keyCode === 13) {

            let mValue = event.target.value;

            setLoading(true);

            if (mValue.length > 0) {

                iniciarSesion();
            }
            else {
                createSweett("", "Debes de ingresar una credencial valida", "warning");

                handleUpdateValues({
                    card_code: "",
                    id_area: 19,
                    id_departament: "",
                    userName: "",
                    password: "",
                });

                setSetFocusCard(true);
                setLoading(false);
            }
        }
    }


    useEffect(() => {

        if (jwt_token !== null && tomaMuestra !== null) {
            props.history.replace(`${process.env.PUBLIC_URL}/dashboard/defaultTomaDeMuestra`);
        }

    }, [props.history])

    ////console.log(departamento);
    const validationLogin = () => {
        let newValidations = {
            id_departament: true,
            card_code: true,
        };

        let isValid = true;

        if (!formValues.id_departament || formValues.id_departament === "0") {
            newValidations.id_departament = false;
            isValid = false;
        }

        if (!formValues.card_code || formValues.card_code.trim() === "") {
            newValidations.card_code = false;
            isValid = false;
        }

        setValidationsLogin(newValidations);
        return isValid;
    };


    return (
        <Container fluid className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh", position: "relative", overflow: "hidden" }}>

            <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backdropFilter: "blur(40px)",
                    WebkitBackdropFilter: "blur(40px)",
                    background: `
                    linear-gradient(
                        to bottom,
                        rgba(161, 201, 221, 0.95) 0%,
                        rgba(133, 202, 236, 0.75) 35%,
                        rgba(87, 212, 250, 0.65) 65%,
                        rgba(17, 125, 212, 0.9) 100%
                    )
                    `,
                }}
            />


            <Row className="w-100 justify-content-center align-items-center">
                <Col xs="12" md="10" lg="9" xl="8">

                    <div className="d-flex flex-column flex-md-row align-items-center justify-content-between"
                        style={{
                            background: "rgba(243, 243, 243, 0.63)",
                            backdropFilter: "blur(18px) saturate(160%)",
                            WebkitBackdropFilter: "blur(18px) saturate(160%)",
                            borderRadius: "24px",
                            boxShadow: `
                                0 20px 40px rgba(0, 0, 0, 0.13),
                                inset 0 1px 0 rgba(255, 255, 255, 0.4)
                            `,
                            padding: "2rem",
                            border: "1px solid rgba(255, 255, 255, 0.25)",
                        }}
                    >



                        <div
                            className="position-absolute d-flex align-items-center"
                            style={{ top: "7px", left: "2%", gap: "4px" }}
                        >
                            <img
                                src={require("../../assets/images/loginHelenLabs/HelenLabs.png")}
                                alt="helenLogo"
                                style={{ width: "20px", height: "auto" }}
                            />

                            <span
                                className="LabelLogin"
                                style={{ fontSize: "12px", letterSpacing: "1px" }}
                            >
                                HELEN
                            </span>

                            <span
                                className="LabelLogin2"
                                style={{ fontSize: "12px", letterSpacing: "1px" }}
                            >
                                LABS
                            </span>
                        </div>




                        {/* ICONO SUPERIOR DERECHO */}
                        {!cardView && (
                            <div
                                onClick={handleViewCard}
                                style={{
                                    position: "absolute",
                                    top: "-7px",
                                    right: "0",
                                    width: "60px",
                                    height: "60px",
                                    backgroundColor: "#0a3d5fe6",
                                    WebkitMaskImage: `url(${require("../../assets/images/loginHelenLabs/TomaDeMuestra/CardLogin.gif")})`,
                                    WebkitMaskRepeat: "no-repeat",
                                    WebkitMaskSize: "contain",
                                    WebkitMaskPosition: "center",
                                    maskImage: `url(${require("../../assets/images/loginHelenLabs/TomaDeMuestra/CardLogin.gif")})`,
                                    maskRepeat: "no-repeat",
                                    maskSize: "contain",
                                    maskPosition: "center",
                                    cursor: "pointer",
                                    zIndex: 10
                                }}
                            />
                        )}

                        {cardView && (

                            <img onClick={handleCloseCard}
                                src={require("../../assets/images/toma/return.png")}
                                alt="decoracion" title='Regresar'
                                style={{
                                    position: "absolute",
                                    top: "1px",
                                    right: "0",
                                    width: "40px",
                                    cursor: 'pointer'

                                }}
                            />
                        )}


                        <div
                            style={{
                                flex: 2,
                                height: "100%",
                                overflow: "hidden",
                                borderRadius: "15px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <img
                                src={require("../../assets/images/toma/tomaC.jpg")}
                                alt="Login Microsite"
                                style={{
                                    width: "117%",
                                    height: "100%",
                                    objectFit: "cover",
                                    borderRadius: "15px",
                                }}

                            />
                        </div>

                        <div
                            style={{
                                flex: 1,
                                padding: "0 2rem",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                height: "100%",
                            }}
                        >

                            <div className="text-center mb-4 mt-1">
                                <span
                                    style={{
                                        fontSize: "20px",
                                        fontWeight: "600",
                                        color: "#023047",
                                        letterSpacing: "1px"
                                    }}
                                >
                                    Toma de Muestra
                                </span>
                                <div
                                    style={{
                                        width: "60px",
                                        height: "2px",
                                        background: "linear-gradient(90deg, #063d5e, #147287)",
                                        margin: "6px auto 0",
                                        borderRadius: "2px"
                                    }}
                                />
                            </div>



                            <div className="text-center mb-3">
                                {
                                    url_helen === cedimi ?
                                        <img
                                            className="b-r-10"
                                            src={require("../../assets/images/microsite/Logo.png")}
                                            style={{ width: "65%", textAlign: "center" }}
                                            alt=""
                                        />
                                        :
                                        <img className="b-r-10" src={ConfigServer.serverUrl + "/api/Configuration/Logo"} style={{ width: "45%" }} alt="logo" />
                                }

                            </div>

                            {/* login form */}
                            <Form className="theme-form text-center" method="get" onSubmit={iniciarSesion}>
                                <div className="mx-auto" style={{ maxWidth: "85%" }}>
                                    <Label>Seleccione una área</Label>

                                    <FormGroup>
                                        <Input
                                            name='id_departament'
                                            type='select'
                                            style={{ cursor: 'pointer', borderRadius: "15px", height: "35px", width: "100%", fontSize: "11px", border: "#147287 1px solid", textAlign: 'center' }}
                                            value={id_departament}
                                            onChange={handleInputChange}

                                        >
                                            <option value={0}>{"Elige tu área"} </option>
                                            {
                                                departamento.length >= 1 && departamento.map((obj, index) => {
                                                    return <option value={obj.id_departament} key={index} >{obj.name}</option>
                                                })
                                            }


                                        </Input>
                                        {submitLogin && !validationsLogin.id_departament && !cardView && (
                                            <div className="text-danger mt-1" style={{ fontSize: '0.9rem' }}>
                                                <i className="fa fa-exclamation-circle mr-2" />
                                                <Label style={{ fontSize: "11px" }}>
                                                    Seleccione una área
                                                </Label>

                                            </div>
                                        )}


                                    </FormGroup>
                                    {!cardView && (
                                        <FormGroup className="animate__animated animate__fadeIn">

                                            <Label>
                                                Ingrese su código
                                            </Label>
                                            <Input name={`card_code`} type="text" style={{ border: " #147287 1px solid", borderRadius: "15px", height: "35px", width: "100%", fontSize: "11px", textAlign: 'center' }} onChange={handleInputChange} />
                                            {submitLogin && !validationsLogin.card_code && (
                                                <div className="text-danger mt-1" style={{ fontSize: '0.9rem' }}>
                                                    <i className="fa fa-exclamation-circle mr-2" />
                                                    <Label style={{ fontSize: "11px" }}>
                                                        Ingrese su código
                                                    </Label>

                                                </div>
                                            )}
                                        </FormGroup>
                                    )}


                                    <Row className={`m-t-10 animate__animated ${cardView ? 'animate__flipInX' : 'animate__flipOutX'}`} style={{ display: cardView ? "flex" : "none" }}>
                                        <Col xs="12" style={{ textAlign: "center" }}>

                                            <div style={{ position: 'absolute', left: "-1000px", top: "-1000px", zIndex: 3 }} className="ocultar-input">
                                                <input id="inputFocusCard" autoFocus={setFocusCard} value={card_code} onChange={(e) => handleSelectValues(e.target.value, "card_code")} onKeyDown={onKeyPressCard} onBlur={cardAutoFocus} />
                                            </div>
                                            <img
                                                src={require("../../assets/images/loginHelenLabs/TomaDeMuestra/CardLogin.gif")}
                                                alt="LogoDNA"
                                                style={{
                                                    width: "55%",
                                                    filter: "brightness(0.5) sepia(1) saturate(500%) hue-rotate(179deg)"
                                                }}
                                            />
                                            <br />
                                            <p className={`incorrect-loginn ${!showText && "d-none"}`}> <i className="fa fa-exclamation-circle" /> Selecciona tu área de trabajo</p>
                                        </Col>
                                    </Row>
                                </div>
                                {!cardView && (
                                    <>


                                        <button
                                            onClick={!loading ? iniciarSesion : undefined}
                                            disabled={loading}
                                            style={{
                                                backgroundColor: "#0b87cfe6",
                                                border: "none",
                                                borderRadius: "15px",
                                                padding: "10px 22px",
                                                fontSize: "14px",
                                                fontWeight: "500",
                                                color: "#fff",
                                                minWidth: "220px",
                                                cursor: 'pointer'
                                            }}

                                        >
                                            {!loading ? (
                                                <>
                                                    <i className="fa fa-sign-in mr-2" />
                                                    Iniciar sesión manual
                                                </>
                                            ) : (
                                                <>
                                                    <span
                                                        className="spinner-border spinner-border-sm mr-2"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                    Cargando...
                                                </>
                                            )}
                                        </button>

                                        <br />

                                        <p className={`incorrect-loginn ${!showText && "d-none"}`}>
                                            <i className="fa fa-exclamation-circle" /> Selecciona tu área de trabajo
                                        </p>

                                    </>
                                )
                                }



                            </Form>
                            <div className={cardView ? "tap-top-regresar" : "d-none"} onClick={handleCloseCard} >
                                Regresar
                            </div>

                        </div>



                    </div>
                </Col>


            </Row>
            {/* </Col> */}
        </Container >

    );

}
export default LoginTomaDeMuestra;
